const frequencies = [
  {
    title: 'A cada 14 dias',
    icon: 'everyOtherWeeky',
    frequency: 14,
  },
  {
    title: 'A cada 31 dias',
    icon: 'monthly',
    frequency: 31,
    popular: true,
  },
  {
    title: 'A cada 45 dias',
    icon: 'fortyFive',
    frequency: 45,
  },
]

export default frequencies;
